import React, { memo, useEffect, useState } from 'react';
import { Image, StyleSheet, View } from 'react-native';

import Backdrop from 'shared/modules/common/components/atoms/Backdrop';
import Animation from 'web/assets/images/logo-animated.gif';

type Props = {
  open: boolean;
  /**
   * Makes sure that the animation completes even if data loading finished quickly
   */
  onComplete?: () => void;
};

// A minimum duration for a better user experience.
// The duration of the entire GIF animation
const LOADING_SCREEN_DURATION = 3600;

const GIF = memo(() => <Image source={{ uri: Animation }} style={style.gif} />);

const Loading = (props: Props) => {
  const [animationCompleted, setAnimationCompleted] = useState(false);
  const [isMounted, setIsMounted] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimationCompleted(true);
      props.onComplete?.();
    }, LOADING_SCREEN_DURATION);

    return () => clearTimeout(timer);
  }, []);

  return isMounted ? (
    <Backdrop
      open={props.open || !animationCompleted}
      onClose={() => setIsMounted(false)}
      style={style.backdrop}
    >
      <View style={style.root}>
        <GIF />
      </View>
    </Backdrop>
  ) : null;
};

const style = StyleSheet.create({
  root: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  backdrop: {
    backgroundColor: 'white',
  },
  gif: {
    width: 100,
    height: 100,
  },
});

export default Loading;
